import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui'
import { Message, MessageBox } from 'element-ui';
import VueClipboard from 'vue-clipboard2'
import { isMobile } from './utils/utils'
import waterfall from 'vue-waterfall2'

// import pagination from "@/components/pagination.vue";
import './icons'
import './styles'

// import '@/permission' // 路由守卫

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.use(waterfall)

Vue.mixin({
  data() {
    return {
      isMobile,
      APP_HOST: process.env.VUE_APP_APP_HOST
    }
  },
  // computed: {
  //   account() {
  //     return this.$store.state.user?.account ?? {}
  //   }
  // }
})

Vue.config.productionTip = false;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$bus = new Vue()

document.body.classList += isMobile ? 'is-mobile' : 'is-pc'

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
